import StyleAPI from "./StyleAPI";
import store from "../../store/index";

const StyleMethods = {
  async getUserStyles(UID) {
    try {
      /** Load and set initial styles from local storage for faster loading experience */
      const storedStyles = localStorage.getItem("styles");
      if (storedStyles) {
        const styles = JSON.parse(storedStyles);
        store.dispatch("style/setStyles", styles);
      }

      /** Perform request to get updated styles from backend */
      const response = await StyleAPI.getUserStyles(UID);
      if (!response || !response.success || !response.data || !response.data.styles) {
        throw new Error("@StyleMethods.getUserStyles: Request failed.");
      }
      const styles = response.data.styles;
      localStorage.setItem("styles", JSON.stringify(styles));
      store.dispatch("style/setStyles", styles);
    } catch (error) {
      console.error("@StyleMethods.getUserStyles: ", error);
    }
  },

  async setNewTheme(UID, themeData) {
    try {
      const response = await StyleAPI.setNewTheme(UID, themeData);
      if (!response || !response.success) {
        throw new Error("@StyleMethods.setNewTheme: Request failed.");
      }
    } catch (error) {
      console.error("@StyleMethods.setNewTheme: ", error);
    }
  },
};

export default StyleMethods;
